import {makeStyles} from '@mui/styles';

// import * as COLORS from 'colors';

const useStyles = makeStyles(() => ({
  content: {},
}));

export default useStyles;
